import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SupportState } from './support.reducer';

export const selectSupport = createFeatureSelector<SupportState>('Support');
export const selectIssues = createSelector(selectSupport, (state: SupportState) => state.issues);
export const selectIssueById = createSelector(selectSupport, (state: SupportState, id: string) =>
    state.issues.find((i) => i._id === id)
);
